// components/cells/CellButton.tsx
import { Button } from "@mui/material";

interface CellButtonProps {
  params: any;
  onClick: (params: any, clickedElement?: string) => void;
  children: React.ReactNode;
}

const CellButton = ({ params, onClick, children }: CellButtonProps) => (
  <Button
    variant="text"
    size="small"
    tabIndex={params.hasFocus ? 0 : -1}
    sx={{
      width: 'fit-content',
      color: 'text.primary',
      textDecoration: 'underline',
      textTransform: 'none',
      fontSize: '14px',
      justifyContent: 'flex-start',
    }}
    onClick={e => {
      e.stopPropagation();
      onClick(params);
    }}
  >
    {children}
  </Button>
);

export default CellButton;
